import { PlatformAnalyticsV2Service } from './PlatformAnalyticsV2Service.generated.es.js';
export { CtaGoal, CtaType, InteractionSource } from './PlatformAnalyticsV2Service.generated.es.js';

var platformAnalyticsV2 = new PlatformAnalyticsV2Service();

export { platformAnalyticsV2 };
